export default function BlobOne ({ color = '#F22D31' }) {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <path transform="translate(100 100)" d="m32.9-52.4c8.3 13.2 12.6 24.7 20.2 37.6s18.5 27.3 18 40.6c-0.6 13.4-12.6 25.7-26.4 34.9s-29.2 15.2-46.4 17.5c-17.1 2.3-35.9 0.8-46-9.5-10.2-10.4-11.7-29.7-17.5-47.5-5.8-17.9-15.9-34.4-14.4-49.5 1.6-15.1 14.9-28.8 30.1-39.8s32.3-19.2 47.1-15.8c14.7 3.4 27 18.3 35.3 31.5z" fill={color} />
    </svg>
  )
}